import { trpc } from '@/utils/trpc'

export const useGetUserInvitations = () => {
  const { data: userInvitations, isLoading: isLoadingTeamInvites } = trpc.getUserInvitations.useQuery()
  return { userInvitations, isLoadingTeamInvites }
}
